import { CSSProperties } from 'react';
import { Cell as TCell, flexRender } from '@tanstack/react-table';
import { TApplication } from 'lendingApi/applications.types';
import styles from './Cell.module.css';

type TProps = {
  cell: TCell<TApplication, unknown>;
};

export const Cell = ({ cell }: TProps) => {
  const baseStyles: CSSProperties = {
    width: cell.column.getSize(),
  };

  return (
    <td style={baseStyles} className={styles.cell}>
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </td>
  );
};
